import React, {useState} from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Button } from 'react-bootstrap';
import SiteUpdateWidget from './SiteUpdateWidget';
import Carousel from '../../components/Carousel';
import './landingPage.css';
import searchIcon from '../../assets/img/SearchIcon.svg';

const HomePage = () => {
  const [localText, setLocalText] = useState("");
  const navigate = useNavigate();
  window.scrollTo(0, 0);

  const handleTextInputChange = (event) => {
    const text = event.target.value;
    setLocalText(text);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      navigate(`/search?search_text=${localText}`);
    }
  };

  return (
      <>
          <div className="searchContainer">
              <div className="heroImage" />
              <div className="heroTextContainer">
                  <div className="heroTextWrapper">
                  <div className="upperImg" />
                      <div className="headerContainer">
                        <div className="headerTitle">
                            Childhood Cancer Data Catalog
                        </div>
                        <div className="headerDesc">
                            A searchable database of pediatric data resources, sharing clinical care and research data generated by the pediatric cancer research community.
                        </div>
                      </div>
                      <div className="heroSearchBox">
                          <div className="search">
                              <label>
                                <div style={{display: 'none'}}>Search for Datasets</div>
                                <input type="text" className="searchTerm" placeholder="Search for Datasets" value={localText} onChange={(e) => handleTextInputChange(e)} onKeyPress={(e) => handleKeyPress(e)} />
                              </label>
                              <Link to={`/search?search_text=${localText}`} className="headerLink">
                                  <button type="submit" className="searchButton">
                                    <img src={searchIcon} alt="search Icon" />
                                  </button>
                              </Link>
                          </div>
                      </div>
                      <div className="headerWidget">
                        <SiteUpdateWidget />
                      </div>
                  </div>
              </div>
          </div>
          <div className="cards">
              <Carousel />
          </div>
          <div className="infoContainer">
              <div className="heroImage2">
                <div className="heroTextContainer2">
                    <div className="heroTextWrapper2">
                    <div className="row">
                        <div className="column1">
                            <div className="headerContent2">
                                What can
                                <br />
                                you expect
                                <br />
                                from the
                                <br />
                                Data Catalog
                            </div>
                        </div>
                        <div className="column2">
                            <p className="infoSection">
                                The CCDI Childhood Cancer Data Catalog is a searchable database of
                                National Cancer Institute and other pediatric cancer resources.
                                <br />
                                <br />
                                Resources include repositories, registries, programs, knowledgebases, analytic tools
                                and catalogs that either manage or refer to data. Users can browse
                                and filter the list of data resources or enter search terms to identify
                                data of interest.
                                <br />
                                <br />
                                Links to those data resources are provided in the browse or search results.
                                <br />
                                <br />
                            </p>
                            <a href="/search" className="headerLink2">
                                <Button className="buttonText color-white">
                                    <span className="buttonLabel">EXPLORE THE CATALOG&emsp;&emsp;&emsp;&emsp;&emsp;</span>
                                    <span className="buttonIcon">
                                        <i className="fas fa-caret-right" />
                                    </span>
                                </Button>
                            </a>
                        </div>
                    </div>
                    </div>
                </div>
              </div>
          </div>
      </>
  );
};

export default HomePage;